<app-notifications-header [enableMarkAll]="allNotificationsSeen(notifications)"
  (markAllAsRead)="onMarkAllAsRead()"
  (close)="onClose()"
 />

<app-loader #loader [loading]="loading" />

<div
  class="h-full overflow-auto"
  infiniteScroll
  [infiniteScrollThrottle]="50"
  [infiniteScrollDistance]="0.5"
  [scrollWindow]="false"
  (scrolled)="onScrolled()"
>
  @if (notifications.length) {
    @for (notification of notifications; track notification) {
      <app-abstract-notification
        (click)="onOpen(notification)"
        [showBadge]="notification.status === notificationStatus.NEW"
      >
        <ng-container notification-icon>
          <i class="icon color-gray" [ngClass]="getNotificationIcon(notification)"></i>
        </ng-container>
        <ng-container notification-title>{{ getNotificationTitle(notification) }}</ng-container>
        <ng-container notification-text>
          @if (isReturnedOrderNotification(notification)) {
            <span class="text-pre-wrap text-break--word" [innerHTML]="getTranslation(notification) | async"></span>
          } @else {
            {{ getTranslation(notification) | async }}
          }

          @if (notification?.detailsBeforeChanges?.length) {
            @for (change of notification.detailsBeforeChanges; track change; let changeIndex = $index) {
              @if (notification.detailsBeforeChanges[changeIndex].value !== notification.detailsAfterChanges[changeIndex].value) {
                <span
                >
                  {{"INQUIRIES.QUOTATIONS.NEW." + notification.detailsBeforeChanges[changeIndex].name | translate }}:
                  <s>{{ notification.detailsBeforeChanges[changeIndex].value}}</s>
                  {{ notification.detailsAfterChanges[changeIndex].value }}
                </span>
              }
            }
          }
        </ng-container>
        <ng-container notification-subtext>
          {{notification.timestamp * 1000 | timeAgo | async }}
        </ng-container>
      </app-abstract-notification>
    }
  } @else {
    <div class="small color-gray p-4 text-center border-bottom">
      {{ 'NOTIFICATIONS.NO_DATA' | translate }}
    </div>
  }
</div>